import { useNavigate } from 'react-router-dom';
import { Clock, ArrowRight, Check } from 'lucide-react';

const SegmentCard = ({ segment, isCompleted }) => {
  const navigate = useNavigate();

  return (
    <div
      data-testid={`home-segment-card-${segment.id}`}
      className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col gap-4 cursor-pointer group"
      onClick={() => navigate(`/session/${segment.id}`)}
    >
      {/* Top row: chip + completion indicator */}
      <div className="flex items-start justify-between">
        <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-gray-100 text-xs font-bold text-ink-secondary tracking-wide">
          {String(segment.id).padStart(2, '0')}
        </span>
        {isCompleted && (
          <span className="w-5 h-5 rounded-full bg-brand-teal/10 flex items-center justify-center">
            <Check size={11} className="text-brand-teal" strokeWidth={3} />
          </span>
        )}
      </div>

      {/* Title */}
      <div className="flex-1">
        <h3 className="font-bold text-ink text-base leading-snug mb-1.5">
          {segment.title}
        </h3>
        <p className="text-ink-secondary text-sm leading-relaxed line-clamp-2">
          {segment.description}
        </p>
      </div>

      {/* Footer: duration + arrow/check button */}
      <div className="flex items-center justify-between mt-auto pt-2 border-t border-gray-50">
        <div className="flex items-center gap-1.5 text-ink-muted text-sm">
          <Clock size={14} strokeWidth={1.8} />
          <span>{segment.duration}</span>
        </div>

        {isCompleted ? (
          <button
            data-testid={`home-segment-check-btn-${segment.id}`}
            onClick={(e) => { e.stopPropagation(); navigate(`/session/${segment.id}`); }}
            className="w-9 h-9 rounded-full bg-brand-teal flex items-center justify-center transition-transform group-hover:scale-105"
            aria-label={`Revisit ${segment.title}`}
          >
            <Check size={16} className="text-white" strokeWidth={2.5} />
          </button>
        ) : (
          <button
            data-testid={`home-segment-arrow-btn-${segment.id}`}
            onClick={(e) => { e.stopPropagation(); navigate(`/session/${segment.id}`); }}
            className="w-9 h-9 rounded-full bg-brand-orange flex items-center justify-center transition-colors hover:bg-brand-orange-hover group-hover:scale-105 transition-transform"
            aria-label={`Start ${segment.title}`}
          >
            <ArrowRight size={16} className="text-white" strokeWidth={2} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SegmentCard;
